import { http } from '../utils/http'

const searchAction = (params,current,size) => {
  const url = `/api/v1/users/page?current=${current}&size=${size}`
  return http.get(url, params)
};
const startAction = (params) => {
  const url = '/api/v1/users/page'
  return http.post(url, params)
};
const stopAction = (params) => {
  const url = '/api/v1/users/page'
  return http.post(url, params)
};
const scheduleAction = (params) => {
  const url = '/api/v1/users/page'
  return http.post(url, params)
};
const pingChannelAction = (params) => {
  const url = '/api/v1/users/page'
  return http.post(url, params)
};
export default {
  searchAction,
  startAction,
  stopAction,
  scheduleAction,
  pingChannelAction,
}
